export default __webpack_public_path__ + "static/media/macbook.906c545a.png";